<template>
  <div>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-row justify="space-between">
        <v-col cols="12" md="4" lg="4" xl="4">
          <div class="d-flex justify-center">
            <v-avatar
              size="114"
              color="primary"
              class="clickable"
              @click="uploadFile"
            >
              <v-progress-circular
                v-if="isSelecting"
                :size="50"
                indeterminate
                color="primary lighten-3"
              ></v-progress-circular>
              <v-img
                v-else
                :src="imageUrl?imageUrl:require('@/assets/avatar.png')"
                alt="profile-image">
              </v-img>
            </v-avatar>
          </div>
          <div class="primary--text small-text d-flex justify-center mb-5 mt-2 clickable">
            <span
              @click="uploadFile"
              class="text-truncate"
            >
              {{ imageName?imageName:'Upload image' }}
            </span>
            <input
              ref="uploader"
              class="d-none"
              type="file"
              accept="image/*"
              @change="onFileChanged"
            >
          </div>
          <!-- Full Name -->
          <v-text-field
            v-model="name"
            placeholder=" "
            class="primary-label"
          >
            <template v-slot:label>
              <span class="font-weight-bold">Full Name</span>
            </template>
          </v-text-field>
          <!-- Birthday -->
          <div class="mt-3">
            <base-date-picker
              v-model="birthday"
              primary-label="Birthdate"
              placeholder=" "
            ></base-date-picker>
          </div>
          <div class="d-flex">
            <!-- Category -->
            <v-select
              v-model="category"
              :items="['Doctor', 'TMA', 'CSR', 'Admin']"
              placeholder=" "
              class="mt-3"
              hide-details
            >
              <template v-slot:label>
                <span class="font-weight-bold primary--text">Category</span>
              </template>
            </v-select>
            <!-- Supervisor -->
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on"
                  class="ml-3 pl-3 pt-2"
                >
                  <v-switch
                    v-model="supervisor"
                    color="primary"
                    inset
                  ></v-switch>
                </div>
              </template>
              <span>Supervisor</span>
            </v-tooltip>
          </div>
        </v-col>
        <v-col cols="12" md="4" lg="4" xl="4">
          <!-- Position -->
          <v-select
            v-model="position"
            :items="specializations"
            item-value="id"
            item-text="specialization"
            placeholder=" "
            class="mt-3"
            :disabled="category!=='Doctor'"
          >
            <template v-slot:label>
              <span class="font-weight-bold primary--text">Specialization</span>
            </template>
          </v-select>
          <!-- SSS No. -->
          <v-text-field
            v-model="sss"
            placeholder=" "
            class="primary-label"
            v-mask="'###-##-####'"
          >
            <template v-slot:label>
              <span class="font-weight-bold">SSS No.</span>
            </template>
          </v-text-field>
          <!-- PhilHealth No. -->
          <v-text-field
            v-model="philhealth"
            placeholder=" "
            class="primary-label mt-3"
            v-mask="'##-#########-#'"
          >
            <template v-slot:label>
              <span class="font-weight-bold">PhilHealth No.</span>
            </template>
          </v-text-field>
          <!-- PAG-IBIG No. -->
          <v-text-field
            v-model="pagibig"
            placeholder=" "
            class="primary-label mt-3"
            v-mask="'####-####-####'"
          >
            <template v-slot:label>
              <span class="font-weight-bold">PAG-IBIG No.</span>
            </template>
          </v-text-field>
          <!-- Phone -->
          <v-text-field
            v-model="phone"
            placeholder=" "
            class="primary-label mt-3"
            hide-details
          >
            <template v-slot:label>
              <span class="font-weight-bold">Phone</span>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12" md="4" lg="4" xl="4">
          <!-- Email -->
          <v-text-field
            v-model="email"
            placeholder=" "
            class="primary-label mt-3"
            :rules="rules.email"
          >
            <template v-slot:label>
              <span class="font-weight-bold">Email
                <span class="red--text">*</span>
              </span>
            </template>
          </v-text-field>
          <!-- Confirm Email -->
          <v-text-field
            placeholder=" "
            class="primary-label"
            :rules="[rules.required, v => v==email || 'Email does not match']"
          >
            <template v-slot:label>
              <span class="font-weight-bold">Confirm Email
                <span class="red--text">*</span>
              </span>
            </template>
          </v-text-field>
          <!-- Password -->
          <v-text-field
            v-model="password"
            placeholder=" "
            class="primary-label"
            :rules="edit ? [] : [rules.required]"
            type="password"
          >
            <template v-slot:label>
              <span class="font-weight-bold">Password
                <span v-if="!edit" class="red--text">*</span>
              </span>
            </template>
          </v-text-field>
          <!-- Address -->
          <v-textarea
            v-model="address"
            placeholder=" "
            auto-grow
            row-height="22"
            class="primary-label mt-3"
          >
            <template v-slot:label>
              <span class="font-weight-bold">Address</span>
            </template>
          </v-textarea>
          <!-- <v-card
            flat
            rounded="lg"
            color="#f1f1f1"
            height="100%"
            class="pa-8"
          >
            <div class="d-flex">
              <h4 class="grey--text text--darken-2">Notes</h4>
              <span class="ml-auto primary--text text-body-2 font-weight-medium">
                <v-icon
                  small
                  color="primary"
                  class="pb-1"
                >
                  mdi-plus
                </v-icon>
                Add Note
              </span>
            </div>
          </v-card> -->
        </v-col>
      </v-row>

      <v-row justify="center">
        <!-- Cancel/Delete Button -->
        <v-btn
          depressed
          rounded
          :color="edit?'red':'primary lighten-5'"
          :class="[edit?'white--text':'primary--text', 'px-6 mx-2']"
          @click="edit?remove.confirm=true:$router.push({name: 'Users'})"
        >
          {{edit?'Delete':'Cancel'}}
        </v-btn>

        <!-- Create/Save Button -->
        <v-btn
          depressed
          rounded
          color="primary"
          class="px-6 mx-2"
          @click="validate()"
        >
          {{edit?'Save':'Add'}}
        </v-btn>
        
        <!-- Reset Password -->
        <v-btn
          v-if="edit"
          depressed
          rounded
          color="warning"
          class="px-6 mx-2"
          @click="resetPassword()"
        >
          Reset Password
        </v-btn>
      </v-row>
    </v-form>

    <!-- confirmation popup -->
    <base-confirmation-dialog
      v-model="add.confirm"
      message="Do you want to add this user?"
      @confirm="confirmAdd"
      @cancel="add.confirm = false"
      confirm-button="Add"
    ></base-confirmation-dialog>

    <base-confirmation-dialog
      v-model="save.confirm"
      message="Do you want to save changes?"
      @confirm="confirmSave"
      @cancel="save.confirm = false"
    ></base-confirmation-dialog>

    <base-confirmation-dialog
      v-model="remove.confirm"
      message="Do you want to remove this user?"
      @confirm="confirmDelete"
      @cancel="remove.confirm = false"
    ></base-confirmation-dialog>

    <base-confirmation-dialog
      v-model="reset.confirm"
      message="Do you want to reset this user's password?"
      @confirm="confirmResetPassword"
      @cancel="reset.confirm = false"
      confirm-button="Ok"
    ></base-confirmation-dialog>

    <!-- error + success popups -->
    <base-confirmation-dialog
      v-model="message.success"
      message="Success!"
      @confirm="message.success = false"
      no-cancel-button
      confirm-button="Ok"
    ></base-confirmation-dialog>

    <base-confirmation-dialog
      v-model="message.error"
      message="Failed."
      @confirm="message.error = false"
      no-cancel-button
      confirm-button="Ok"
    ></base-confirmation-dialog>
  </div>
</template>

<script>
import BaseDatePicker from '../../../../components/BaseDatePicker.vue'
  export default {
  components: { BaseDatePicker },
    name: "UserForm",

    props: {
      //
    },

    data: () => ({
      imageUrl: null,
      imageName: '',
      valid: false,
      rules: {
       required: v => !!v || "This field is required",
       email: [
         v => !!v || "This field is required.",
         v => /.+@.+\..+/.test(v) || 'Email must be valid'
        ],
      },
      isSelecting: false,
      /* popups */
      remove: {
        confirm: false
      },
      save: {
        confirm: false
      },
      add: {
        confirm: false
      },
      message: {
        error: false,
        success: false
      },
      reset: {
        confirm: false
      },
      password: null
    }),

    watch: {
      category(val) {
        if (val !== 'Doctor') {
          this.position = ''
        }
      }
    },

    computed: {
      edit() { return this.$route.params.id !== 'add' ? true : false },
      id() { return this.$route.params.id },
      name: {
        get() { return this.$store.getters['user/name'] },
        set(val) { this.$store.commit('user/setField', {name: 'name', value: val}) }
      },
      image: {
        get() { return this.$store.getters['user/image'] },
        set(val) { this.$store.commit('user/setField', {name: 'image', value: val}) }
      },
      category: {
        get() { return this.$store.getters['user/category'] },
        set(val) { this.$store.commit('user/setField', {name: 'category', value: val}) }
      },
      supervisor: {
        get() { return this.$store.getters['user/supervisor'] },
        set(val) { this.$store.commit('user/setField', {name: 'supervisor', value: val}) }
      },
      position: {
        get() { return this.$store.getters['user/position'] },
        set(val) { this.$store.commit('user/setField', {name: 'position', value: val}) }
      },
      birthday: {
        get() { return this.$store.getters['user/birthday'] },
        set(val) { this.$store.commit('user/setField', {name: 'birthday', value: val}) }
      },
      sss: {
        get() { return this.$store.getters['user/sss'] },
        set(val) { this.$store.commit('user/setField', {name: 'sss', value: val}) }
      },
      philhealth: {
        get() { return this.$store.getters['user/philhealth'] },
        set(val) { this.$store.commit('user/setField', {name: 'philhealth', value: val}) }
      },
      pagibig: {
        get() { return this.$store.getters['user/pagibig'] },
        set(val) { this.$store.commit('user/setField', {name: 'pagibig', value: val}) }
      },
      email: {
        get() { return this.$store.getters['user/email'] },
        set(val) { this.$store.commit('user/setField', {name: 'email', value: val}) }
      },
      phone: {
        get() { return this.$store.getters['user/phone'] },
        set(val) { this.$store.commit('user/setField', {name: 'phone', value: val}) }
      },
      address: {
        get() { return this.$store.getters['user/address'] },
        set(val) { this.$store.commit('user/setField', {name: 'address', value: val}) }
      },
      // notes: {
      //   get() { return this.$store.getters['user/notes'] },
      //   set(val) { this.$store.commit('user/setField', {name: 'notes', value: val}) }
      // },
      specializations() {
        return this.$store.getters['specialization/specializations']
      }
    },

    async mounted() {
      await this.$store.dispatch('specialization/fetchSpecializations')
    },

    methods: {
      async validate() {
        let data = {
          name: this.name,
          image: this.image,
          birthday: this.birthday,
          email: this.email,
          position: this.position,
          address: this.address,
          category: this.category,
          sss: this.sss,
          philhealth: this.philhealth,
          pagibig: this.pagibig
        }

        if (this.password) {
          data.password = this.password
        }

        console.log('form-inputs', data)
        await this.$refs.form.validate();
        if (this.valid) {
          this.edit
            ? this.save.confirm = true
            : this.add.confirm = true
        }
      },
      async confirmAdd() {
        try {
          var response = await this.$store.dispatch('user/addUser')
          if (response.status == 200) {
            this.message.success = true
            this.$router.push({ name: 'Users'})
            this.$store.dispatch('user/fetchUsers', {page: 1, per_page: 12, no_patient: true, update_sort: true, tma_and_doctors_only: true})
          }
          else {
            this.message.error = true
          }
        }
        catch(e) {
          console.log('[error]', e)
          this.message.error = true
        }
      },
      async confirmSave() {
        try {
          var response = await this.$store.dispatch('user/editUser', this.id)
          response.status == 200 ? this.message.success = true : this.message.error = true
        }
        catch(e) {
          console.log('[error]', e)
          this.message.error = true
        }
      },
      async confirmDelete() {
        try {
          var response = await this.$store.dispatch('user/deleteUser', this.id)
          if (response.status == 200) {
            this.message.success = true
            this.$router.push({ name: 'Users'})
          }
          else {
            this.message.error = true
          }
        }
        catch(e) {
          console.log('[error]', e)
          this.message.error = true
        }
      },
      uploadFile() {
        this.isSelecting = true
        window.addEventListener('focus', () => {
          this.isSelecting = false
        }, { once: true })

        this.$refs.uploader.click()
      },
      onFileChanged(e) {
        var files = e.target.files || e.dataTransfer.files;
        this.createImage(files[0]);
        this.imageName = files[0].name
      },
      createImage(file) {
        // var image = new Image();
        var reader = new FileReader();

        reader.onload = (e) => {  
          this.imageUrl = e.target.result;
        };
        reader.readAsDataURL(file);
        // console.log(this.imageUrl, this.image, this.imageName)
      },
      resetPassword() {
        // console.log(this.email, "email")
        this.reset.confirm = true
        // this.$store.dispatch('user/resetUserPasswordViaEmail', this.email)
      },
      async confirmResetPassword() {
        let response = await this.$store.dispatch('user/resetUserPasswordViaEmail', this.email)

        console.log({ response }, 'confirmResetPassword')

        if (response.success) {
          this.message = {
            success: true,
            error: false
          }
        } else {
          this.message = {
            success: false,
            error: true
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
// .v-text-field {
//   width: 85% !important;
// }

.small-text {
  font-size: 12px;
}
</style>